import { Button, ButtonGroup, Field, Link } from 'Components/Core';
import { ListFieldSection, PageSection } from 'Components/Layout';
import { ListDropdown } from 'Components/List';
import { useState } from 'react';
import { actions } from 'Data/ReduxViewModels/Admin';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'Data/Redux';
import { IRunAgsExportParams } from '../types';

const AgsExportConfigurationRunExportAdmin: React.FC<IRunAgsExportParams> = ({
  configurationId,
  workOrderUUID,
  workOrderName,
}) => {
  const dispatch = useDispatch();
  const isRunning = useSelector((state: RootState) => state.admin.agsExportConfiguration.agsExport.running);
  const exported = useSelector((state: RootState) => state.admin.agsExportConfiguration.agsExport.exported);
  const [options, setOptions] = useState<any>(workOrderUUID ? { label: workOrderName, value: workOrderUUID } : null);

  const handleClick = () => {
    dispatch(
      actions.runNewAgsExport({
        workOrderId: options.value,
        configurationId: configurationId,
      })
    );
  };

  const handleDropDownChanged = (evt: any) => {
    setOptions(evt.data.value ? { label: evt.data.value.label, value: evt.data.value.value } : null);
    dispatch(actions.runNewAgsExportReset());
  };

  return (
    <PageSection heading="Export Testing">
      <ListFieldSection single>
        <Field
          input={<ListDropdown />}
          label="Work Order"
          value={options}
          endpoint="list.workorders"
          queryParams={{ orderBy: 'workOrderId asc' }}
          onChange={handleDropDownChanged}
        />
        <ButtonGroup>
          <Button primary onClick={handleClick} disabled={!options} loading={isRunning}>
            Run Export
          </Button>
        </ButtonGroup>

        {exported && (
          <Field
            input={<Link />}
            to={`/ags/workorders/${options?.value}`}
            content={`Go to ${options?.label} AGS export page`}
          />
        )}
      </ListFieldSection>
    </PageSection>
  );
};

export { AgsExportConfigurationRunExportAdmin };
